import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation8({ animation, badge, all_animations }: Props) {
  const [showBadge, setShowBadge] = useState(false)
  const [ripples, setRipples] = useState<number[]>([])

  useEffect(() => {
    setTimeout(() => setShowBadge(true), 200)

    // Créer des cercles qui s'expandent
    const createRipple = (index: number) => {
      setRipples(prev => [...prev, index])
    }

    for (let i = 0; i < 6; i++) {
      setTimeout(() => createRipple(i), i * 400)
    }
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes rippleExpand {
          0% {
            transform: scale(0);
            opacity: 1;
            border-width: 8px;
          }
          100% {
            transform: scale(4);
            opacity: 0;
            border-width: 1px;
          }
        }
        .ripple {
          animation: rippleExpand 2s ease-out forwards;
        }
        @keyframes breathe {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        .breathe {
          animation: breathe 2s ease-in-out infinite;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh] relative">
        {/* Cercles concentriques */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          {ripples.map((index) => (
            <div
              key={index}
              className="ripple absolute w-32 h-32 sm:w-40 sm:h-40 rounded-2xl border-tessan-yellow"
              style={{
                borderStyle: 'solid',
                animationDelay: `${index * 0.1}s`
              }}
            />
          ))}
        </div>

        {/* Badge central */}
        <div className={`relative z-10 transition-all duration-500 ${showBadge ? 'scale-100 opacity-100' : 'scale-0 opacity-0'}`}>
          <div className="breathe w-32 h-32 sm:w-40 sm:h-40 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50">
            <span className="text-5xl sm:text-7xl">{badge.emoji}</span>
          </div>
        </div>

        <div className={`mt-8 text-center transition-all duration-700 delay-500 ${showBadge ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
